import styled, { css } from 'styled-components';
import { colors, screenSize } from '../../../styleGuide';

export const CarouselContainer = styled.div`
  position: relative;
  .alice-carousel__dots {
    padding: 0 1rem 0 0;
    position: relative;
    bottom: 3rem;
    margin: 0 auto;
    max-width: 68.75rem;
    right: auto !important;
    text-align: right;
    width: 100%;
  }
  .alice-carousel__dots-item {
    width: 1.25rem;
    height: 1.25rem;
    &.__active {
      background-color: ${colors.blue.primary};
    }
  }
  .alice-carousel__dots-item:not(.__active) {
    background-color: ${colors.white};
    border: 1px solid ${colors.blue.primary};
  }
  .alice-carousel__dots-item:not(:last-child) {
    margin-right: 0.94rem;
  }
  @media (max-width: ${screenSize.mobileL}) {
    .alice-carousel__dots {
      display: none;
    }
  }
  @media (max-width: ${screenSize.laptop}) {
    .alice-carousel__dots {
      right: 2%;
    }
  }
`;

const getSharedButtonStyles = mode => {
  const isClient = mode === 'client';
  return css`
    background-color: ${isClient ? colors.blue.primary : colors.white};
    cursor: pointer;
    height: 7.5rem;
    width: 3.75rem;
    color: ${isClient ? colors.white : colors.blue.primary};
    position: absolute;
    top: 25%;
    padding: 0.62rem;
    border: none;
    transition: 0.3s;
    svg {
      fill: ${isClient ? colors.white : colors.blue.primary};
      width: 1.4rem;
      height: auto;
    }
    &:focus,
    &:hover {
      outline: 0;
      background-color: ${isClient ? colors.gray.dark : colors.blue.primary};
      svg {
        fill: ${colors.white};
      }
    }
    @media (max-width: ${screenSize.tablet}) {
      height: 5rem;
      width: 2.5rem;
      padding: 0;
      top: ${isClient ? '40%' : '20%'};
    }
    @media (max-width: ${screenSize.mobileL}) {
      height: 3.75rem;
      width: 1.87rem;
      padding: 0;
      top: ${isClient ? '38%' : '5%'};
    }
  `;
};

export const PrevButton = styled.button`
  ${props => getSharedButtonStyles(props.mode)}
  text-align: left;
  left: 0;
  border-bottom-right-radius: 5.62rem;
  border-top-right-radius: 5.62rem;
`;

export const NextButton = styled.button`
  ${props => getSharedButtonStyles(props.mode)}
  text-align: right;
  right: 0;
  border-bottom-left-radius: 5.62rem;
  border-top-left-radius: 5.62rem;
`;
